const initialState = {
    auditRecordsTypeFilters: {},
    processRegistryStatusFilters: {},
    processRegistrySourcesFilters: {},
    auditDateFilterDates: { toDate: undefined, fromDate: undefined },
}

const reducer = (state = initialState, action) => {

    if (action.type === 'changeAuditRecordsTypeFilters') {
        return {
            ...state,
            auditRecordsTypeFilters: action.newAuditRecordsTypeFilters
        }
    }

    if (action.type === 'changeProcessRegistryStatusFilters') {
        return {
            ...state,
            processRegistryStatusFilters: action.newProcessRegistryStatusFilters
        }
    }

    if (action.type === 'changeProcessRegistrySourcesFilters') {
        return {
            ...state,
            processRegistrySourcesFilters: action.newProcessRegistrySourcesFilters
        }
    }

    if (action.type === 'changeAuditDateFilterDates') {
        return {
            ...state,
            auditDateFilterDates: action.newAuditDateFilterDates
        }
    }

    return state;
}

export default reducer;